import ReactDOM from "react-dom";
const ConfirmationModal = ({ onClose, onConfirm, errorMessage }) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-[400px]">
        <h2 className="text-lg font-bold mb-4">Confirmar Exclusão</h2>
        <p className="mb-6">Tem certeza que deseja excluir este item?</p>
        {errorMessage && (
          <p className="text-red-500 text-center mb-4">{errorMessage}</p>
        )}
        <div className="flex justify-end gap-4">
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            onClick={async () => {
              const errorMessage = await onConfirm();
              if (!errorMessage) onClose();
            }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
export default ConfirmationModal;
